import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

export const scheduleSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'scheduleType': createNonDisplayOptionDefinition('scheduleType', OrderKeys.scheduleType),
  'scheduledAction': createNonDisplayOptionDefinition('scheduledAction', OrderKeys.scheduledAction),
  'taskCount': createNonDisplayOptionDefinition('taskCount', OrderKeys.taskCount),
  'parallel': createNonDisplayOptionDefinition('parallel', OrderKeys.parallel),
  'runNextAt': createNonDisplayOptionDefinition('runNextAt', OrderKeys.runNextAt),
};
